import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ChevronLeft } from "lucide-react";
import QualificationSettings from "../../components/qualifications/QualificationSettings";

const QualificationSettingsPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto px-4 py-8">
            {/* Header with Back Button */}
            <div className="flex items-center gap-4 mb-8">
                <Button 
                    variant="ghost" 
                    size="icon" 
                    onClick={() => navigate(-1)}
                    className="rounded-full hover:bg-slate-100"
                >
                    <ChevronLeft className="h-6 w-6 text-slate-600" />
                </Button>
                <div>
                    <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Qualification Settings</h1>
                    <p className="text-slate-500 text-sm mt-1">
                        Configure qualification types and system-wide notification defaults
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="w-full">
                <QualificationSettings />
            </div>
        </div>
    );
};

export default QualificationSettingsPage;
